let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b0Nov")).then(() => parcelRequire('5B42Z'));